import React, { useState } from 'react'
import { useTestContext } from '../TestContext'
import Button from 'app/components/Button'
import CustomModal from 'app/components/CustomModal'

const FlagEvidenceModal: React.FC = () => {
  const {
    isFlagModalOpen,
    isFlagging,
    handleCloseFlagModal,
    handleConfirmFlag,
  } = useTestContext()

  const [localFlagReason, setLocalFlagReason] = useState('')

  const handleFlagSubmit = async () => {
    await handleConfirmFlag(localFlagReason)
    setLocalFlagReason('')
  }

  const handleClose = () => {
    handleCloseFlagModal()
    setLocalFlagReason('')
  }

  return (
    <CustomModal
      show={isFlagModalOpen}
      onClose={handleClose}
    >
      <p className='fw-bold mb-1 fs-2 text-gray-900'>Flag Evidence</p>
      <p className='text-gray-900 fs-7' style={{textAlign: 'left', marginBottom: '20px'}}>
        Reason for the flag will be posted as a note on this test for this evidence.
      </p>
      <div className='mb-4'>
        <textarea
          className='form-control'
          placeholder='Reason...'
          value={localFlagReason}
          onChange={(e) => setLocalFlagReason(e.target.value)}
          rows={4}
        />
      </div>
      <div className='d-flex justify-content-end gap-3'>
        <Button btnType='secondary' onClick={handleClose}>
          Cancel
        </Button>
        <Button
          btnType='destructive'
          onClick={handleFlagSubmit}
          disabled={isFlagging || !localFlagReason.trim()}
        >
          {isFlagging ? (
            <>
              Flagging...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </>
          ) : (
            'Flag'
          )}
        </Button>
      </div>
    </CustomModal>
  )
}

export default FlagEvidenceModal 